import { Mic, MicOff, Volume2, VolumeX, PhoneOff, Monitor, Settings } from 'lucide-react';
import clsx from 'clsx';

interface VoiceControlsProps {
  isConnected: boolean;
  isMuted: boolean;
  isDeafened: boolean;
  onConnect: () => void;
  onDisconnect: () => void;
  onToggleMute: () => void;
  onToggleDeafen: () => void;
  onScreenShare?: () => void;
  onSettings?: () => void;
  isScreenSharing?: boolean;
}

interface ControlButtonProps {
  onClick: () => void;
  isActive?: boolean;
  isDanger?: boolean;
  disabled?: boolean;
  title: string;
  children: React.ReactNode;
}

function ControlButton({ onClick, isActive, isDanger, disabled, title, children }: ControlButtonProps) {
  return (
  <button
      onClick={onClick}
      disabled={disabled}
      title={title}
      className={clsx(
    'p-3 rounded-full transition-all',
    isDanger
          ? 'bg-accent-rose text-white hover:bg-accent-rose/80'
          : isActive
      ? 'bg-accent-violet text-white hover:bg-accent-violet/80'
      : 'bg-surface-tertiary text-text-secondary hover:bg-surface-hover hover:text-text-primary',
    disabled && 'opacity-50 cursor-not-allowed'
      )}
  >
      {children}
  </button>
  );
}

export function VoiceControls({
  isConnected,
  isMuted,
  isDeafened,
  onConnect,
  onDisconnect,
  onToggleMute,
  onToggleDeafen,
  onScreenShare,
  onSettings,
  isScreenSharing,
}: VoiceControlsProps) {
  if (!isConnected) {
  return (
      <div className="flex items-center justify-center gap-4">
    <button
          onClick={onConnect}
          className={clsx(
      'flex items-center gap-2 px-6 py-3 rounded-lg font-medium transition-colors',
      'bg-accent-emerald text-white hover:bg-accent-emerald/90'
          )}
    >
          <Mic className="w-5 h-5" />
          Unisciti al canale
    </button>
      </div>
  );
  }

  return (
  <div className="flex items-center justify-center gap-3">
      {/* Mute button */}
      <ControlButton
    onClick={onToggleMute}
    isActive={!isMuted}
    title={isMuted ? 'Riattiva microfono' : 'Disattiva microfono'}
      >
    {isMuted ? (
          <MicOff className="w-5 h-5" />
    ) : (
          <Mic className="w-5 h-5" />
    )}
      </ControlButton>

      {/* Deafen button */}
      <ControlButton
    onClick={onToggleDeafen}
    isActive={!isDeafened}
    title={isDeafened ? 'Riattiva audio' : 'Disattiva audio'}
      >
    {isDeafened ? (
          <VolumeX className="w-5 h-5" />
    ) : (
          <Volume2 className="w-5 h-5" />
    )}
      </ControlButton>

      {/* Screen share button */}
      {onScreenShare && (
    <ControlButton
          onClick={onScreenShare}
          isActive={isScreenSharing}
          title={isScreenSharing ? 'Interrompi condivisione' : 'Condividi schermo'}
    >
          <Monitor className="w-5 h-5" />
    </ControlButton>
      )}

      {/* Settings button */}
      {onSettings && (
    <ControlButton
          onClick={onSettings}
          title="Impostazioni audio"
    >
          <Settings className="w-5 h-5" />
    </ControlButton>
      )}

      {/* Disconnect button */}
      <ControlButton
    onClick={onDisconnect}
    isDanger
    title="Disconnetti"
      >
    <PhoneOff className="w-5 h-5" />
      </ControlButton>
  </div>
  );
}
